import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse } from '@/types/api'
import type { AuthSession } from '@/types/auth'
import type { DesafioConfirmacao } from '@/features/biometria/types/biometria'

import type {
  ForgotPasswordRequest,
  LoginRequest,
  ResetPasswordRequest,
} from '../types/authRequests'

export const authApi = {
  login: async (body: LoginRequest): Promise<AuthSession> => {
    const response = await httpClient.post<ApiResponse<AuthSession>>('/auth/login', body)
    return unwrap(response)
  },

  /** Sem access token: a sessão é identificada pelo cookie (`withCredentials`). */
  opcoesDesbloqueio: async (): Promise<DesafioConfirmacao> =>
    unwrap(await httpClient.post<ApiResponse<DesafioConfirmacao>>('/auth/desbloqueio/opcoes')),

  /** Mesmo formato do login; renova o cookie de refresh. */
  desbloquear: async (body: {
    desafioId: string
    resposta: AuthenticationResponseJSON
  }): Promise<AuthSession> =>
    unwrap(await httpClient.post<ApiResponse<AuthSession>>('/auth/desbloqueio', body)),

  logout: async (): Promise<void> => {
    await httpClient.post('/auth/logout')
  },

  forgotPassword: async (body: ForgotPasswordRequest): Promise<void> => {
    await httpClient.post('/auth/forgot-password', body)
  },

  resetPassword: async (body: ResetPasswordRequest): Promise<void> => {
    await httpClient.post('/auth/reset-password', body)
  },
}
